import React from 'react';
import {
  elementAttributesToProps,
  RehydratorFunction,
} from '@tr-digital/react-rehydrate';
import { ICommunityBannerProps } from '../types';
import { CommunityBanner } from '../CommunityBanner';

const rehydrator: RehydratorFunction = async (domNode) => {
  const props: ICommunityBannerProps = elementAttributesToProps(domNode);

  return Promise.resolve(<CommunityBanner {...props} />);
};

export default rehydrator;
